module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAoCAMAAABU4iNhAAAAOVBMVEUAAAD///////////////////////////////////////////////////////////////////////8KOjVvAAAAEnRSTlMAgEAg8ODA39C1kHBQEKCfTzCaui2qAAAAX0lEQVQ4y+3QSQqAMBBE0c5gnOL0739YISsRQgq35q0/NF3WdTIXJ1PkEfDWdCVQym0BqVwjUulHUMow83C4itNsQBP08nV9dxW5fDQBH1bSl28KSSoLP5RS4mKy7h9ub9ANJ0jw/rQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/reserve/questionnaire/back.png
// module id = AmyS
// module chunks = 1